import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgDeposit = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M14 27.96c0-6.11 0-9.164 1.898-11.062S20.851 15 26.96 15h10.8c6.11 0 9.164 0 11.062 1.898s1.898 4.953 1.898 11.062c0 6.11 0 9.164-1.898 11.062S43.869 40.92 37.76 40.92h-10.8c-6.11 0-9.164 0-11.062-1.898S14 34.069 14 27.96"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M49.345 27.96c0-3.093-.003-5.275-.225-6.927-.217-1.612-.62-2.512-1.27-3.163-.651-.65-1.55-1.054-3.163-1.27-1.651-.223-3.834-.225-6.927-.225h-10.8c-3.093 0-5.275.003-6.927.225-1.612.216-2.512.62-3.163 1.27-.65.651-1.054 1.551-1.27 3.163-.222 1.652-.225 3.834-.225 6.927s.003 5.275.225 6.927c.216 1.612.62 2.512 1.27 3.163.651.65 1.551 1.054 3.163 1.27 1.652.222 3.834.225 6.927.225h10.8c3.093 0 5.276-.003 6.928-.225 1.611-.216 2.51-.62 3.162-1.27.65-.651 1.053-1.551 1.27-3.163.222-1.652.225-3.834.225-6.927m2.75 0c0 3.016.003 5.416-.25 7.294-.257 1.917-.804 3.493-2.051 4.74s-2.823 1.794-4.74 2.052c-1.878.252-4.278.249-7.294.249h-10.8c-3.016 0-5.416.003-7.294-.25-1.917-.257-3.493-.804-4.74-2.05-1.247-1.248-1.794-2.824-2.052-4.741-.252-1.878-.249-4.278-.249-7.294s-.003-5.416.249-7.294c.258-1.917.805-3.493 2.052-4.74s2.823-1.794 4.74-2.052c1.878-.252 4.278-.249 7.294-.249h10.8c3.016 0 5.416-.003 7.294.249 1.917.258 3.493.805 4.74 2.052s1.794 2.823 2.052 4.74c.252 1.878.249 4.278.249 7.294"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M37.76 27.96a5.4 5.4 0 1 1-10.8 0 5.4 5.4 0 0 1 10.8 0"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M36.385 27.96a4.025 4.025 0 1 0-8.05 0 4.025 4.025 0 0 0 8.05 0m2.75 0a6.775 6.775 0 1 1-13.55 0 6.775 6.775 0 0 1 13.55 0"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M44.24 32.28v-8.64zm-23.76 0v-8.64z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M19.105 32.28v-8.64a1.375 1.375 0 1 1 2.75 0v8.64a1.375 1.375 0 1 1-2.75 0m23.76 0v-8.64a1.375 1.375 0 0 1 2.75 0v8.64a1.375 1.375 0 1 1-2.75 0M30.625 56v-5.68l-1.652 1.653a1.376 1.376 0 0 1-1.946-1.946l4-4 .105-.093c.54-.441 1.337-.41 1.84.093l4 4a1.376 1.376 0 0 1-1.945 1.946l-1.652-1.653V56a1.375 1.375 0 1 1-2.75 0"
      />
    </svg>
  );
};
export default SvgDeposit;
